module.exports = __webpack_public_path__ + "img/Fichier 36.f47621a3.png";